import { PERIOD } from '../../../constants/shared/CommonConstants';
import {
    SWITCH_INSTRUCTION_DATE,
    SWITCH_INSTRUCTION_GRADE,
    FETCH_CHECKPOINTS,
    FETCH_FAKE_CHECKPOINTS,
    SAVE_CHECKPOINT,
    CLEAR_CHECKPOINTS,
    FETCH_ALL_OBSERVATIONS,
    VIEW_LATEST_UPDATE_RECOMMENDATION,
} from '../../actionTypes/shared/apiActionTypes';
import { parseCheckPoints, parseSaveCheckPoints } from './instructionReducerParsers';

export const initialState = {
    selectedInstructionDate: null,
    selectedInstructionGrade: null,
    areCheckPointsFetched: false,
    checkPoints: {},
    error: null,
    isCheckPointSaving: false,
    observations: [],
    areObservationsFetching: false,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SWITCH_INSTRUCTION_DATE:
        case VIEW_LATEST_UPDATE_RECOMMENDATION:
            return {
                ...state,
                selectedInstructionDate: action.payload.date,
            };
        case SWITCH_INSTRUCTION_GRADE:
            return {
                ...state,
                selectedInstructionGrade: action.selectedInstructionGrade,
                selectedInstructionDate: null,
            };
        case FETCH_CHECKPOINTS.START:
            return {
                ...state,
                areCheckPointsFetched: false,
            };
        case FETCH_CHECKPOINTS.SUCCESS:
            return {
                ...state,
                areCheckPointsFetched: true,
                checkPoints: parseCheckPoints(action.response, [
                    PERIOD.BOY,
                    PERIOD.MOY,
                    PERIOD.EOY,
                    PERIOD.SUMMER,
                ]),
            };
        case FETCH_CHECKPOINTS.ERROR:
            return {
                ...state,
                areCheckPointsFetched: true,
                error: action.error,
            };
        case FETCH_FAKE_CHECKPOINTS.START:
        case SAVE_CHECKPOINT.START:
            return {
                ...state,
                isCheckPointSaving: true,
            };
        case SAVE_CHECKPOINT.SUCCESS:
            return {
                ...state,
                isCheckPointSaving: false,
                checkPoints: { ...parseSaveCheckPoints(state.checkPoints, action.response) },
                selectedInstructionDate: null,
            };
        case SAVE_CHECKPOINT.ERROR:
            return {
                ...state,
                isCheckPointSaving: false,
                error: action.error,
            };
        case FETCH_FAKE_CHECKPOINTS.SUCCESS:
            return {
                ...state,
                isCheckPointSaving: false,
            };
        case CLEAR_CHECKPOINTS:
            return {
                ...state,
                checkPoints: {},
                areCheckPointsFetched: false,
            };
        case FETCH_ALL_OBSERVATIONS.START:
            return {
                ...state,
                areObservationsFetching: true,
            };
        case FETCH_ALL_OBSERVATIONS.SUCCESS:
            return {
                ...state,
                areObservationsFetching: false,
            };
        case FETCH_ALL_OBSERVATIONS.ERROR:
            return {
                ...state,
                areObservationsFetching: false,
                error: action.error,
            };
        default:
            return state;
    }
};

const getSelectedInstructionGrade = state => state.selectedInstructionGrade;

const getSelectedInstructionDate = state => state.selectedInstructionDate;

const getCheckPoints = state => state.checkPoints;

const areCheckPointsFetched = state => state.areCheckPointsFetched;

const isCheckPointSaving = state => state.isCheckPointSaving;

const getObservations = state => state.observations;

const areObservationsFetching = state => state.areObservationsFetching;

export const selectors = {
    getSelectedInstructionDate,
    getSelectedInstructionGrade,
    getCheckPoints,
    areCheckPointsFetched,
    isCheckPointSaving,
    areObservationsFetching,
    getObservations,
};
